import { Model } from '@vuex-orm/core'
import MZLoyalty from './MZLoyalty'
import MZCoupon from './MZCoupon'
import MZLocationable from './MZLocationable'
import MZInterestCategory from './MZInterestCategory'

export default class MZLocation extends Model {
  static entity = 'mzlocations'
  static primaryKey = 'id'

  static fields () {
    return {
      id: this.string(''),
      account_id: this.attr(''),
      account_name: this.attr(''),
      account_description: this.attr(''),
      directory_list_locations: this.attr(''),
      name: this.attr(''),
      store_number: this.attr(''),
      address1: this.string(''),
      address2: this.attr(''),
      locality: this.string(''),
      region: this.string(''),
      postalcode: this.attr(''),
      country: this.attr(''),
      phone_number: this.attr(''),
      latitude: this.attr(''),
      longitude: this.attr(''),
      timezone: this.attr(''),
      meta_data: this.attr(''),
      distance: this.attr(''),
      image: this.attr(''),
      coverImage: this.attr(''),
      beacon_region_id: this.attr(''),
      social_share: this.attr(''),
      interestCategories: this.morphedByMany(MZInterestCategory, MZLocationable, 'location_id', 'locationable_id', 'locationable_type'),
      coupons: this.morphedByMany(MZCoupon, MZLocationable, 'location_id', 'locationable_id', 'locationable_type'),
      loyalty: this.morphedByMany(MZLoyalty, MZLocationable, 'location_id', 'locationable_id', 'locationable_type')

    }
  }
}



// WEBPACK FOOTER //
// ./src/models/MZLocation.js